/******************************************************************
 * Archivo : client/src/queries/fetchUserSurveys.js
 * Proyecto: CB30
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query UserSurveys {
    user {
      id

      tipoPerfil

      roles {
        code
        label
      }

      surveys {
        surveyId
      }

      person {
        genero
        nivel_educativo
        estrato
        departamento
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/fetchUserSurveys.js